import { InputType } from 'config'
import { getLoanTypeMapForSelect } from 'reducers/loanDetail.reducer'

export const defaultInputs = (): Record<string, InputType> => {
  return {
    loanType: {
      inputType: 'multiselect',
      title: 'Loan Type',
      options: getLoanTypeMapForSelect(),
      value: {},
      required: true,
      defaultSelected: false,
    },
    title: {
      inputType: 'text',
      title: 'Title',
      required: true,
    },
    days: {
      inputType: 'text',
      type: 'number',
      title: 'Days',
      required: true,
    },
    isOnlyExpiredDate: {
      inputType: 'togglebutton',
      title: 'Is Only Expired Date?',
      required: true,
    },
    calculateBasedOn: {
      inputType: 'select',
      title: 'Calculate based on',
      options: {
        1: 'Today Date',
        2: 'Closing Date',
      },
    },
    isSeasoning: {
      inputType: 'togglebutton',
      title: 'Is Seasoning?',
      required: true,
    },
    isRequired: {
      inputType: 'togglebutton',
      title: 'Is Required?',
      required: true,
    },
    isVisible: {
      inputType: 'togglebutton',
      title: 'Visible?',
      required: true,
      value: true,
      visible: false,
    },
    visibleLogic: {
      inputType: 'visibleLogic',
      title: '',
      required: false,
      value: [],
      options: {
        hasNotVisible: true,
      },
      visible: false,
    },
    // isCoBorrower: {
    //   inputType: 'togglebutton',
    //   title: 'Is Coborrower?',
    //   required: true,
    // },
  }
}
